'use strict';

module.exports = function () {
  try {
    var canvas = document.createElement('canvas');
    return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
  } catch (e) {
    return false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-three-renderer/lib/utils/isWebglSupported.js
// module id = 1377
// module chunks = 1